"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M19.092 19.028c-1.958 1.958-4.31 2.949-7.057 2.972-2.747.023-5.095-.94-7.042-2.887l-.157-.157v1.354c0 .338-.128.633-.382.884a1.228 1.228 0 0 1-.89.377c-.339 0-.635-.127-.887-.38a1.215 1.215 0 0 1-.38-.887l-.005-4.474c0-.396.133-.726.4-.992.265-.266.596-.4.991-.4l4.475.006c.339 0 .635.126.887.38.253.252.38.547.38.886 0 .34-.128.636-.382.89a1.22 1.22 0 0 1-.89.382H6.809l.142.141c1.4 1.401 3.09 2.095 5.068 2.083 1.977-.012 3.678-.73 5.1-2.152.224-.224.43-.457.616-.698.187-.24.352-.499.497-.774a1.8 1.8 0 0 1 .812-.779 1.47 1.47 0 0 1 1.08-.077c.393.12.668.357.826.713a1.18 1.18 0 0 1-.04 1.068 8.436 8.436 0 0 1-.803 1.339c-.309.42-.647.814-1.015 1.182ZM6.882 6.948c-.225.225-.43.458-.617.699-.187.24-.352.499-.497.774a1.838 1.838 0 0 1-.82.787 1.467 1.467 0 0 1-1.09.085 1.2 1.2 0 0 1-.807-.696 1.177 1.177 0 0 1 .022-1.052 9.485 9.485 0 0 1 1.834-2.57C6.867 3.017 9.22 2.025 11.968 2c2.75-.024 5.098.937 7.046 2.885l.157.157V3.698c0-.339.126-.634.379-.887.252-.253.548-.38.887-.38.339 0 .636.128.89.383.254.254.382.55.382.89v4.469a1.368 1.368 0 0 1-1.386 1.386l-4.475-.006a1.22 1.22 0 0 1-.89-.381 1.22 1.22 0 0 1-.381-.89c0-.339.127-.636.381-.89a1.22 1.22 0 0 1 .89-.382l1.35.006-.142-.142c-1.401-1.4-3.091-2.094-5.071-2.08-1.98.014-3.68.732-5.103 2.155Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};